// Created to prevent ocassional bugs when rounding using the {num + Number.EPSILON) * 10) / 10} method

function roundNumber(num, positions) {
    return +(Math.round(num + "e+" + positions) + "e-" + positions)
}

export default roundNumber
